export const SANGER_COLORS = {
  A: '#0000FF', // Blue
  C: '#FF0000', // Red
  G: '#00FF00', // Green
  T: '#000000', // Black
  N: '#888888'  // Gray for unknown
} as const;

export type BaseKey = keyof typeof SANGER_COLORS;

export const colorOfBase = (b: string): string => {
  const key = (b || 'N').toUpperCase() as BaseKey;
  return SANGER_COLORS[key] ?? SANGER_COLORS.N;
};
